module.exports = __webpack_public_path__ + "eb49e9cc058285056ec3a00ce34b8098.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-clark.png
// module id = 652
// module chunks = 0